import React, { lazy } from 'react';
import { CtaButton } from './CtaButton';
import { CheckCircle2, Sparkles, Video } from 'lucide-react';
const benefits = ['Acceso Permanente', 'Soporte + Actualizaciones', '6 BONOS de regalo 🎁', 'Garantía de satisfacción'];
export function PricingSection() {
  return <section id="pricing" className="px-4 md:px-6 py-12 flex flex-col items-center text-center w-full max-w-7xl mx-auto pt-[0px] pb-[0px]" data-id="element-269">
      {/* Premium neon container — matching the rest of the page */}
      <div className="w-full max-w-3xl relative rounded-[3rem] p-[2px] bg-gradient-to-b from-[#D98BAF] via-brand-pinkDark/50 to-[#D98BAF]/20 shadow-[0_25px_60px_-15px_rgba(217,139,175,0.5)]" data-id="element-270">
        <div className="bg-brand-navy rounded-[2.9rem] px-5 py-10 md:px-12 md:py-14 relative overflow-hidden flex flex-col items-center" data-id="element-271">
          {/* Ambient neon glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[700px] bg-[#D98BAF]/15 blur-[140px] rounded-full pointer-events-none" data-id="element-272" />

          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-6 backdrop-blur-sm relative z-10" data-id="element-273">
            <Sparkles size={16} strokeWidth={2.5} data-id="element-274" />
            Valor por tiempo limitado
          </div>

          <p className="text-white/70 font-serif text-lg md:text-2xl mb-4 tracking-wide relative z-10" data-id="element-275">
            ¡Este valor especial estará sólo por tiempo limitado!
          </p>

          {/* Neon highlighted title */}
          <h2 className="neon-title font-black text-[42px] md:text-[72px] leading-[1.05] tracking-tight uppercase mb-12 relative z-10" style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 900
        }} data-id="element-276">
            Accedé Ahora
          </h2>

          {/* Offer Card */}
          <div className="w-full max-w-xl bg-white rounded-[2.5rem] overflow-hidden flex flex-col items-center pb-10 shadow-[0_20px_50px_-12px_rgba(217,139,175,0.4)] border border-[#D98BAF]/40 relative z-10" data-id="element-277">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-cream via-[#D98BAF] to-brand-cream" data-id="element-278"></div>

            {/* Main Mockup */}
            <img src="https://cdn.magicpatterns.com/uploads/p3ogb6j1yeC81svYinY9QR/pasted-image.png" alt="Mockup completo del programa" loading="lazy" decoding="async" className="w-full h-auto mb-6 md:scale-105 drop-shadow-xl" data-id="element-279" />

            {/* Benefits List */}
            <ul className="text-left px-8 w-full space-y-4 mb-6 max-w-md" data-id="element-280">
              {benefits.map((item, i) => <li key={i} className="flex gap-4 font-serif text-brand-navy/90 text-lg items-start" data-id="element-281">
                  <CheckCircle2 className="text-[#D98BAF] shrink-0 mt-0.5" size={22} strokeWidth={2.5} data-id="element-282" />
                  <span className="leading-snug" data-id="element-283">{item}</span>
                </li>)}
            </ul>

            {/* Premium Highlighted: 2 consultorías en vivo */}
            <div className="px-6 w-full mb-8 max-w-md" data-id="element-284">
              <div className="relative w-full rounded-2xl p-[2px] bg-gradient-to-r from-emerald-400 via-emerald-500 to-emerald-400 shadow-[0_10px_30px_-8px_rgba(16,185,129,0.5)]" data-id="element-285">
                {/* Premium sticker */}
                <div className="absolute -top-3 right-4 bg-emerald-500 text-white text-[10px] md:text-xs font-black uppercase tracking-widest px-3 py-1 rounded-full shadow-md flex items-center gap-1 z-10" data-id="element-286">
                  <Sparkles size={12} strokeWidth={3} data-id="element-287" />
                  Premium incluido
                </div>
                <div className="flex items-start gap-3 bg-emerald-50 rounded-2xl px-4 py-4 md:px-5 md:py-5" data-id="element-288">
                  <div className="w-9 h-9 shrink-0 rounded-full bg-emerald-500 flex items-center justify-center shadow-[0_0_15px_rgba(16,185,129,0.5)] mt-0.5" data-id="element-289">
                    <CheckCircle2 size={20} strokeWidth={2.5} className="text-white" data-id="element-290" />
                  </div>
                  <span className="font-sans font-bold text-emerald-900 text-base md:text-lg leading-snug text-left flex items-center gap-2 flex-wrap" data-id="element-291">
                    <Video size={18} className="text-emerald-600 shrink-0" strokeWidth={2.5} data-id="element-292" />
                    2 consultorías semanales en vivo con Brenda incluidas.
                  </span>
                </div>
              </div>
            </div>

            {/* Pricing */}
            <div className="flex flex-col items-center w-full px-6" data-id="element-293">
              <p className="text-red-500/80 font-sans font-bold text-xl md:text-2xl line-through mb-1 tracking-widest uppercase" data-id="element-294">
                ANTES $149.999 ARS
              </p>
              <p className="text-brand-navy font-black text-4xl md:text-5xl mb-4 tracking-tight" data-id="element-295">
                ¡SÓLO POR HOY! 😱
              </p>

              <div className="flex flex-col items-center mb-6" data-id="element-296">
                <span className="text-emerald-500 font-black md:text-[84px] tracking-tighter drop-shadow-sm text-[42px]" data-id="element-297">
                  $49.999 ARS
                </span>
                <span className="text-emerald-500 font-black text-3xl md:text-4xl tracking-[0.2em] mt-[-5px]" data-id="element-298"></span>
              </div>

              {/* Premium Sticker */}
              <div className="inline-flex items-center gap-2 md:gap-3 max-w-full bg-emerald-500 text-white px-4 md:px-5 py-2 rounded-full mb-8 shadow-[0_8px_20px_-4px_rgba(16,185,129,0.4)] border border-white/20 transform hover:scale-105 transition-transform" data-id="element-299">
                <span className="font-bold text-[11px] md:text-sm tracking-wide uppercase whitespace-nowrap" data-id="element-300">
                  100% Recomendado
                </span>
                <span className="text-yellow-300 text-xs md:text-sm whitespace-nowrap drop-shadow-sm" data-id="element-301">
                  ★★★★★
                </span>
              </div>

              <p className="text-brand-navy/50 font-serif italic text-xl md:text-2xl mb-8" data-id="element-302">
                Hasta 3 cuotas
              </p>
            </div>

            {/* CTA Button - Green Neon (slim & modern) */}
            <div className="px-6 w-full mb-5 relative group" data-id="element-303">
              <a href="https://qpx0er-vn.myshopify.com/cart/47110721011796:1?channel=buy_button" target="_blank" rel="noopener noreferrer" className="btn-neon-green w-full py-5 md:py-6 px-5 rounded-2xl flex items-center justify-center text-white transition-all duration-300 hover:scale-[1.02] active:scale-95 relative overflow-hidden" data-id="element-304">
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full group-hover:animate-shine pointer-events-none" data-id="element-305" />

                <span className="font-bold md:text-xl tracking-tight uppercase drop-shadow-sm text-center text-[20px]" data-id="element-306">
                  Acceso ahora · 7 días de garantía ⭐️
                </span>
              </a>
              <p className="text-brand-navy/40 text-[11px] md:text-xs font-semibold tracking-wide uppercase mt-3 text-center" data-id="element-307">
                Compra 100% segura y protegida
              </p>
            </div>

            {/* Payment Badges */}
            <div className="flex flex-col items-center gap-0 px-6 w-full opacity-90" data-id="element-308">
              <img src="https://cdn.magicpatterns.com/uploads/dLNqUGgPbTw3PFKmET984a/pasted-image.jpg" alt="Métodos de pago — Site seguro SSL certificado, compra 100% segura" loading="lazy" decoding="async" className="w-full h-auto max-w-full block rounded-2xl mt-2" data-id="element-309" />
            </div>
          </div>

          {/* Guarantee Section */}
          <div className="mt-10 flex flex-col items-center max-w-md w-full relative z-10" data-id="element-310">
            <div className="w-full bg-[#151522] rounded-[2rem] p-8 md:p-10 flex flex-col items-center shadow-[0_20px_50px_-12px_rgba(217,139,175,0.15)] border border-white/10 relative overflow-hidden" data-id="element-311">
              {/* Top Glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 bg-[#D98BAF]/20 blur-[50px] pointer-events-none" data-id="element-312"></div>

              {/* Shield Icon */}
              <div className="w-20 h-20 bg-gradient-to-b from-[#D98BAF] to-brand-pinkDark rounded-2xl flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(217,139,175,0.4)] relative z-10" data-id="element-313">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-314">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-315" />
                </svg>
              </div>

              <h3 className="text-[#D4AF37] font-sans font-black text-2xl md:text-3xl text-center mb-8 uppercase tracking-tight leading-tight" data-id="element-316">
                GARANTÍA 7 DÍAS — SIN PREGUNTAS
              </h3>

              {/* Inner Box */}
              <div className="w-full border border-white/10 bg-white/[0.02] rounded-2xl p-6 md:p-8 flex flex-col items-center text-center mb-6" data-id="element-317">
                <p className="text-white/90 font-sans text-lg md:text-xl font-medium mb-6" data-id="element-318">
                  Accedes al programa. Lo aplicás en tus videos.
                </p>
                <p className="text-white/80 font-sans text-base md:text-lg mb-6" data-id="element-319">
                  Si en 7 días no es exactamente lo que esperabas:
                </p>
                <p className="text-[#D98BAF] font-sans font-black text-3xl md:text-4xl mb-6 drop-shadow-[0_0_15px_rgba(217,139,175,0.3)]" data-id="element-320">
                  devolución del 100%
                </p>
                <p className="text-white font-sans font-bold text-lg md:text-xl" data-id="element-321">
                  sin formularios, sin drama, sin explicaciones.
                </p>
              </div>

              <p className="text-white/50 font-sans text-sm md:text-base" data-id="element-322">
                Tasa de devoluciones:{' '}
                <strong className="text-[#D98BAF] font-bold" data-id="element-323">
                  menos del 1%
                </strong>
                .
              </p>
            </div>

            <div className="space-y-8 w-full max-w-md" data-id="element-324">
              <h3 className="text-white font-sans font-bold text-3xl md:text-4xl tracking-tight pt-[15px] pb-[15px]" data-id="element-325">
                ¿Dudas? <br data-id="element-326" />{' '}
                <span className="text-[#D98BAF]" data-id="element-327">¡Comunícate conmigo!</span>
              </h3>

              <a href="https://api.whatsapp.com/send/?phone=5491169196692&text=Hola+Quiero+acceder+a+la+formular+creadora+de+contenido+UGC.+Mi+nombre+es+&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="block w-full max-w-sm mx-auto transition-transform hover:scale-105 active:scale-95" data-id="element-328">
                <img src="https://cdn.magicpatterns.com/uploads/jywVCyikDEJMp2T5JmNzTH/pasted-image.png" alt="Whatsapp Soporte" loading="lazy" decoding="async" className="w-full h-auto drop-shadow-[0_10px_25px_rgba(37,211,102,0.3)]" data-id="element-329" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}